import * as R from 'remeda';
import { LanguageCode } from 'humanize-duration';
import en from './en/en.json';

export const defaultLocales = en;

export const markValuesWithLineNumbers = (locales: Record<string, string>) => {
  if (localStorage.getItem('localizationToolsEnabled') !== 'true') {
    return locales;
  }

  return R.mapValues(locales, (value, key) => {
    const findIn = (allKeys: string[], type: string) => {
      const index = allKeys.indexOf(key);
      if (index >= 0) {
        // line numbers are 1-based and first line is always "{", that's why +2
        return `[${type}${index + 2}] ${value}`;
      }
      return undefined;
    };

    return findIn(Object.keys(en), '') ?? value;
  });
};

export const humanizeDurationLocaleMap: Record<string, LanguageCode> = {
  zh: 'zh_CN',
  'pt-br': 'pt',
};

export type NeverTranslated<K extends string = '%'> =
  TranslationEnv['enabled'] extends false ? never : `missing:${K}`;

export type LocalizationKeys = TranslationEnv['enabled'] extends false
  ? keyof typeof defaultLocales
  : NeverTranslated;
